import React, {useState} from 'react'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../_metronic/partials'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import PurchaseModal from './PurchaseModal'
import Watch from '../../../../media/StorageAI/ic-watch.svg'
import CalendarRepeat from '../../../../media/StorageAI/ic-calendar-repeat.svg'

const StorageCard = (details: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [isModalActive, setIsModalActive] = useState<boolean>(false)
  return (
    <>
      <div className={`d-flex card p-4 ${mode === 'dark' ? 'bg-light' : ''}`}>
        <div className='d-flex flex-md-row flex-column justify-content-between'>
          <div className='d-flex gap-4 align-items-center mb-md-0 mb-4 me-md-auto me-4'>
            <div style={{width: '15%', minWidth: '80px'}}>
              <CircularProgressbar
                className='w-100'
                value={
                  parseInt(details?.details?.initialValueBar) < 1
                    ? 1
                    : parseInt(details?.details?.initialValueBar)
                }
                text={`${
                  parseFloat(details?.details?.initialValueBar) < 1
                    ? '<1%'
                    : `${parseFloat(details?.details?.initialValueBar)}%`
                }`}
                strokeWidth={18}
                styles={buildStyles({
                  strokeLinecap: 'round',
                  textSize: '16px',
                  pathTransitionDuration: 0.5,
                  pathColor:
                    parseInt(details?.details?.initialValueBar) < 80
                      ? '#4776E6'
                      : parseInt(details?.details?.initialValueBar) === 100
                      ? '#E05243'
                      : '#F8CA28',
                  textColor: mode === 'dark' ? 'White' : 'Black',
                  trailColor: mode === 'dark' ? '#4A6FA6' : '#D6ECFD',
                })}
              />
            </div>
            <div className='d-flex flex-column w-100'>
              <div className='d-flex align-items-center mb-2 gap-2'>
                {details?.details?.recurringType === 'recurring' && (
                  <img width={20} height={20} src={CalendarRepeat} alt='calendar repeat' />
                )}
                <h1 className='d-flex align-items-center gap-1 mb-0 font-size-14 fw-semibold'>
                  {details?.details?.title === 'Team Member'
                    ? details?.details?.title + 's'
                    : details?.details?.title}
                  {parseInt(details?.details?.extraValueBar) < 80 ? (
                    ''
                  ) : parseInt(details?.details?.extraValueBar) === 100 ? (
                    <ToolTipUI
                      isRedCaution='true'
                      tooltipText={formatMessage({
                        id: 'Your utilized storage is reaching its limit soon. Please add more storage to avoid any disruption.',
                      })}
                    />
                  ) : (
                    <ToolTipUI
                      isYellowCaution='true'
                      tooltipText={formatMessage({
                        id: 'Your AI Search and Retrieval quota is exhausted. Please Add More to resume.',
                      })}
                    />
                  )}
                </h1>
              </div>
              <>
                {' '}
                <p className='mb-0 font-size-13 fw-normal'>
                  {formatMessage({
                    id: `${
                      details?.details?.initialValue.slice(-2) === 'MB' ||
                      details?.details?.initialValue.slice(-2) === 'GB' ||
                      details?.details?.initialValue.slice(-2) === 'TB'
                        ? details?.details?.initialValue.slice(0, -2) +
                          ' ' +
                          details?.details?.initialValue.slice(-2)
                        : details?.details?.initialValue
                    }
                      /
                      ${
                        details?.details?.initialStorage.slice(-2) === 'MB' ||
                        details?.details?.initialStorage.slice(-2) === 'GB' ||
                        details?.details?.initialStorage.slice(-2) === 'TB'
                          ? details?.details?.initialStorage.slice(0, -2) +
                            ' ' +
                            details?.details?.initialStorage.slice(-2)
                          : details?.details?.initialStorage.slice(-6) === 'Member'
                          ? details?.details?.initialStorage + 's'
                          : details?.details?.initialStorage
                      }`,
                  })}
                  <span className='text-primary'>
                    {formatMessage({id: ' (Included in Subscription Plan)'})}
                  </span>
                </p>
                {details?.details?.status === 'Active' && (
                  <p className='mb-0 font-size-13 fw-normal'>
                    {formatMessage({
                      id: `${
                        details?.details?.extraValue.slice(-2) === 'MB' ||
                        details?.details?.extraValue.slice(-2) === 'GB' ||
                        details?.details?.extraValue.slice(-2) === 'TB'
                          ? details?.details?.extraValue.slice(0, -2) +
                            ' ' +
                            details?.details?.extraValue.slice(-2)
                          : details?.details?.extraValue
                      }
                        /
                        ${
                          details?.details?.extraStorage.slice(-2) === 'MB' ||
                          details?.details?.extraStorage.slice(-2) === 'GB' ||
                          details?.details?.extraStorage.slice(-2) === 'TB'
                            ? details?.details?.extraStorage.slice(0, -2) +
                              ' ' +
                              details?.details?.extraStorage.slice(-2)
                            : details?.details?.extraStorage.slice(-6) === 'Member'
                            ? details?.details?.extraStorage + 's'
                            : details?.details?.extraStorage
                        }`,
                    })}
                    <span className='text-success'>
                      {formatMessage({id: ' (Additionally Purchased)'})}
                    </span>
                  </p>
                )}
              </>
            </div>
          </div>
          <div className='d-flex align-items-start'>
            <button
              className='btn bg-primary text-white custom-button-property font-size-13 w-100 text-nowrap'
              onClick={() => setIsModalActive(true)}
            >
              {formatMessage({id: 'Buy More'})}
            </button>
          </div>
        </div>
        <div className='mt-4'>
          <div className='d-flex flex-md-row flex-column justify-content-between'>
            <label className='form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
              {formatMessage({id: 'Additionally Purchased'})} {details?.details?.detail}{' '}
              {details?.details?.recurringType === 'recurring'
                ? `(Billed ${details?.details?.duration === 'Monthly' ? 'Monthly' : 'Yearly'})`
                : `(One-time Purchase, Valid Forever)`}
              <span>
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `Additionally Purchased ${details?.details?.title}`,
                  })}
                />
              </span>
            </label>
            <div className='d-flex justify-content-end'>
              <p className='font-size-13 text-dark d-flex mb-0'>
                {`${
                  details?.details?.extraStorage.slice(0, 1) === '0'
                    ? ''
                    : details?.details?.extraValue.slice(-2) === 'MB' ||
                      details?.details?.extraValue.slice(-2) === 'GB' ||
                      details?.details?.extraValue.slice(-2) === 'TB'
                    ? details?.details?.extraValue.slice(0, -2) +
                      ' ' +
                      details?.details?.extraValue.slice(-2)
                    : details?.details?.extraValue
                }
                  ${details?.details?.extraStorage.slice(0, 1) === '0' ? '' : '/'}
                  ${
                    details?.details?.extraStorage.slice(0, 1) === '0'
                      ? ''
                      : details?.details?.extraStorage.slice(-2) === 'MB' ||
                        details?.details?.extraStorage.slice(-2) === 'GB' ||
                        details?.details?.extraStorage.slice(-2) === 'TB'
                      ? details?.details?.extraStorage.slice(0, -2) +
                        ' ' +
                        details?.details?.extraStorage.slice(-2)
                      : details?.details?.extraStorage.slice(-6) === 'Member'
                      ? details?.details?.extraStorage + 's'
                      : details?.details?.extraStorage
                  }`}
                <span
                  className={`${
                    details?.details?.status === 'Active'
                      ? 'text-success'
                      : details?.details?.status === 'Over'
                      ? 'text-danger'
                      : 'text-primary'
                  }`}
                >
                  <ul>
                    <li>{details?.details?.status}</li>
                  </ul>
                </span>
              </p>
            </div>
          </div>
          <div className='w-100 d-flex align-items-center gap-2 mb-4'>
            <div className='h-8px progress' style={{width: '100%'}}>
              <div
                className={`progress-bar ${
                  parseInt(details?.details?.extraValueBar) < 80
                    ? 'bg-primary'
                    : parseInt(details?.details?.extraValueBar) === 100
                    ? 'bg-danger'
                    : 'bg-warning'
                }`}
                role='progressbar'
                style={{width: `${details?.details?.extraValueBar}%`}}
              ></div>
            </div>
          </div>
          <div className='d-flex'>
            <>
              <p className='mb-0'>
                <img src={Watch} alt='Watch' className='me-2' />
                <span className='text-muted'>
                  {formatMessage({id: 'Estimated Limit Reset Date: '})}
                </span>
                {details?.details?.estimatedLimit || '-'}
              </p>
              {details?.details?.recurringType === 'recurring' ? (
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: 'Since this is a recurring add-on, it will automatically renew on this date.',
                  })}
                />
              ) : (
                <ToolTipUI
                  tooltipText={formatMessage({
                    id: `This is the expiry date of the purchased add-on. If it says 'Not Applicable' the add-on is valid forever and will not expire.`,
                  })}
                />
              )}
            </>
          </div>
        </div>
      </div>

      <PurchaseModal
        isModalActive={isModalActive}
        setIsModalActive={setIsModalActive}
        item={details?.details}
      />
    </>
  )
}

export default StorageCard
